<!-- Иконка маршрута со стартовой и конечной точками. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="6" cy="19" r="3" :stroke="stroke" stroke-width="2" />
    <circle cx="18" cy="5" r="3" :stroke="stroke" stroke-width="2" />
    <path
      d="M9 19H17.5C22 19 22 12 17.5 12H6.5C2 12 2 5 6.5 5H15"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "RouteIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
